import { SERVICE_PROVIDERS } from 'modules/graphql/types';

export const EMAIL_SERVICE_PROVIDERS = [
  SERVICE_PROVIDERS.ITERABLE,
  SERVICE_PROVIDERS.DYN,
  SERVICE_PROVIDERS.SENDGRID,
  SERVICE_PROVIDERS.SPARKPOST,
  SERVICE_PROVIDERS.SPARKPOST_EU,
  SERVICE_PROVIDERS.SPARKPOST_ELITE,
  SERVICE_PROVIDERS.MAILGUN,
  SERVICE_PROVIDERS.MAILGUN_EU,
  SERVICE_PROVIDERS.CUSTOM_MTA,
  SERVICE_PROVIDERS.SES_THIRD_PARTY,
];

export const SMS_SERVICE_PROVIDERS = [SERVICE_PROVIDERS.TELNYX, SERVICE_PROVIDERS.TWILIO];

export const WHATS_APP_SERVICE_PROVIDERS = [SERVICE_PROVIDERS.INFOBIP];

export const SPARKPOST_PROVIDERS = [
  SERVICE_PROVIDERS.SPARKPOST,
  SERVICE_PROVIDERS.SPARKPOST_EU,
  SERVICE_PROVIDERS.SPARKPOST_ELITE,
];

export const MAILGUN_PROVIDERS = [SERVICE_PROVIDERS.MAILGUN, SERVICE_PROVIDERS.MAILGUN_EU];
